import React from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'

const container = document.getElementById('root')

if (!container) {
    throw new Error('Taskpane root element was not found.')
}

createRoot(container).render(<App />)
